import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import MaterialTable from '../../../shared/components/material-table';
import columns from './AnthropometricColumns';
import { anthropometricMeasurementsPropTypes } from '../../../shared/utils/SmartPropTypes';

const Anthropometric = ({ t, anthropometricMeasurements }) => {
  const getLabel = () => {
    return (
      !!anthropometricMeasurements &&
      `${anthropometricMeasurements.student.fullName} ${anthropometricMeasurements.formattedMeasureDate}`
    );
  };

  const getData = () => {
    return anthropometricMeasurements ? [anthropometricMeasurements] : [];
  };

  return (
    <>
      <div className="h6 mb-3">{getLabel()}</div>
      <div className="mb-3">
        <MaterialTable
          data={getData()}
          toolbar={false}
          columns={columns(t)}
          pageSize={1}
          paging={false}
        />
      </div>
    </>
  );
};

Anthropometric.propTypes = {
  t: PropTypes.func.isRequired,
  anthropometricMeasurements: anthropometricMeasurementsPropTypes,
};

Anthropometric.defaultProps = {
  anthropometricMeasurements: undefined,
};

export default withTranslation('common')(Anthropometric);
